export default "__VITE_ASSET__52713616__"